import styled from 'styled-components';

export const WrapperResale = styled.div`
  width: 100%;
  max-width: 787px;
  display: flex;
  flex-direction: column;
  padding: 0;

  @media (max-width: 1200px) {
    max-width: 100%;
    padding: 0 16px;
    padding-bottom: 300px;
  }
`;

export const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SectionTitle = styled.h2`
  font-family: 'Elza', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  padding: 16px 0;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const EventHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.surface.base};
  border-radius: 8px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const EventImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`;

export const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const EventTitle = styled.h2`
  font-family: 'Elza', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const EventVenue = styled.p`
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const HeaderPage = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 0;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TitlePage = styled.h1`
  font-family: 'Elza', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  padding: 0;
  margin: 0;

  @media (max-width: 1200px) {
    font-size: 18px;
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const TicketCard = styled.div`
  background: ${({ theme }) => theme.colors.surface.high};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TicketHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const TicketInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const TicketName = styled.h3`
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const TicketGroup = styled.p`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const TicketPrice = styled.div`
  font-family: 'Elza', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
`;

export const BuyerSection = styled.div`
  background: ${({ theme }) => theme.colors.surface.base};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
`;

export const BuyerTitle = styled.h2`
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const BuyerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BuyerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BuyerAvatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`;

export const BuyerDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BuyerName = styled.p`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const BuyerEmail = styled.p`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ProceedButton = styled.button`
  width: 100%;
  padding: 16px;
  background: ${({ theme }) => theme.colors.button.surface.primary};
  color: ${({ theme }) => theme.colors.button.text.primary};
  border: none;
  border-radius: 8px;
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.button.hover.primary};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.button.surface.disabled};
    color: ${({ theme }) => theme.colors.button.text.disabled};
    cursor: not-allowed;
  }
`;

export const LoginPrompt = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: ${({ theme }) => theme.colors.surface.low};
  border-radius: 8px;
  margin-bottom: 24px;
  gap: 8px;
`;

export const LoginPromptText = styled.p`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;
